import React from "react";
import { useHistory } from "react-router";
import { Card } from "antd";

const HomeCard = (props) => {
  let history = useHistory();
  const redirect = () => {
    if (!props.hasOwnProperty('link')) {
      return;
    }

    let propertiesHistory = {
      pathname: props.link,
      from: "HomePage",
      state: {}
    };

    if (props.hasOwnProperty('event')) {
      propertiesHistory['state']['event'] = props.event;
    }

    history.push(propertiesHistory);
  }

  return (
    <Card
      hoverable
      className="home-card"
      onClick={redirect}
      cover={props.icon}
    >
      <div className="home-card-title">
        {props.title}
      </div>
    </Card>
  );
}

export default HomeCard;